<div
  (click)="clicked(); isReadonly() ? null : $event.stopPropagation()"
  [class.hover-opacity]="!isReadonly()"
  [matTooltipDisabled]="!projectIndustry()?.industry()"
  [matTooltip]="'project-tasks.list.column-headers.industry' | translate"
  class="flex w-full min-w-0 items-center gap-2"
>
  @if (showIcon()) {
    <mat-icon
      fontIcon="business_center"
      class="icon-muted shrink-0"
    />
  }

  @if (!minimalMode()) {
    <p
      [class.text-sm]="isSmall()"
      [class.opacity-50]="!industryPresent()"
      [class.lowercase]="!industryPresent()"
      class="truncate min-w-0"
    >
      @if (industryPresent()) {
        {{ projectIndustry()?.industry()?.name }}
      } @else if (isSmall()) {
        —
      } @else {
        {{ 'project-tasks.list.column-headers.industry' | translate }}
      }
    </p>
  }
</div>
